import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React, { forwardRef } from 'react';
import PaperComponent from './PaperComponent';

const RadDialog = forwardRef(
  (
    {
      isOpen,
      onClose,
      title,
      children,
      actions,
      fullWidth = true,
      maxWidth = 'sm',
      showCloseButton = true,
      ...dialogProps
    },
    ref
  ) => {
    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        PaperComponent={PaperComponent}
        ref={ref}
        {...dialogProps}
      >
        {title && (
          <DialogTitle
            sx={{
              px: 'var(--canvas-dialog-body-px, 24px)',
              pt: 2.25,
              pb: 1,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h6" sx={{ fontFamily: 'var(--canvas-font-ui)', letterSpacing: '0.01em' }}>
                {title}
              </Typography>
              {showCloseButton && (
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={onClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
          </DialogTitle>
        )}
        <DialogContent
          sx={{
            // Restore body padding after DialogTitle (MUI defaults pt to 0).
            pt: 'var(--canvas-dialog-body-pt, 20px) !important',
            pb: 'var(--canvas-dialog-body-pb, 20px)',
            px: 'var(--canvas-dialog-body-px, 24px)',
          }}
        >
          {children}
        </DialogContent>
        {actions && (
          <DialogActions
            sx={{
              px: 'var(--canvas-dialog-body-px, 24px)',
              pb: 2.25,
              pt: 1,
              gap: 'var(--canvas-dialog-actions-gap, 10px)',
            }}
          >
            {actions}
          </DialogActions>
        )}
      </Dialog>
    );
  }
);

export default RadDialog;
